import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/score';

const initialState = Immutable.fromJS({
  data: [],
  export: {},
  loading: false,
  loaded: false
})

export default handleActions({
  // 积分查询
  [actions.getScoreSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getScoreFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  // 用户积分导出
  [actions.getScoreExportRequested](state) {
    return state.delete('error').set('loading', true)
  },
  [actions.getScoreExportSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true).update('export', v => v.merge(Immutable.fromJS(payload)));
  },
  [actions.getScoreExportFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/score.js